export interface CloudWord {
  word: string;
  count: number;
}

const MIN_PX = 14;
const MAX_PX = 40;
// Dark enough for text on the light page background.
const INKS = ['text-ink', 'text-accent', 'text-accent', 'text-accent'];

const hash = (word: string) => [...word].reduce((h, ch) => (h * 31 + ch.charCodeAt(0)) >>> 0, 7);

/** Words sized by how often they come back. Placement is a fixed shuffle by word, so it reads as a cloud and never jumps. */
export default function WordCloud({ words, unit }: { words: CloudWord[]; unit: string }) {
  if (!words.length) return null;
  const counts = words.map((w) => w.count);
  const lo = Math.min(...counts);
  const hi = Math.max(...counts);
  const size = (n: number) => (hi === lo ? (MIN_PX + MAX_PX) / 2 : MIN_PX + ((n - lo) / (hi - lo)) * (MAX_PX - MIN_PX));
  const placed = [...words].sort((a, b) => hash(a.word) - hash(b.word));
  return (
    <ul className="flex flex-wrap items-baseline justify-center gap-x-5 gap-y-1 py-2 leading-tight">
      {placed.map((w) => (
        <li
          key={w.word}
          title={`${w.word}: ${w.count} ${unit}`}
          className={`${INKS[hash(w.word) % INKS.length]} ${w.count === hi ? 'font-semibold' : ''}`}
          style={{ fontSize: `${Math.round(size(w.count))}px` }}
        >
          {w.word}
          <span className="sr-only">
            , {w.count} {unit}
          </span>
        </li>
      ))}
    </ul>
  );
}
